import React, { useState } from "react";
import { Link } from "react-router-dom";
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LayersIcon from '@mui/icons-material/Layers';
import AlignHorizontalCenterIcon from '@mui/icons-material/AlignHorizontalCenter';
import AlignVerticalCenterIcon from '@mui/icons-material/AlignVerticalCenter';
import GridOnIcon from '@mui/icons-material/GridOn';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

interface DashboardProps {
  activeOverlay?: string;
}

const designs = [
  "/static/images/enhance_img.png",
  "/static/images/design1.png",
  "/static/images/design2.png",
  "/static/images/design3.png",
  "/static/images/design4.png",
  "/static/images/design5.png",
  "/static/images/design6.png",
];

const Dashboard: React.FC<DashboardProps> = ({ activeOverlay }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const handlePrev = () => {
    setActiveIndex((prev) => (prev > 0 ? prev - 1 : designs.length - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev < designs.length - 1 ? prev + 1 : 0));
  };

  const toggleFullScreen = () => {
    setIsPreviewOpen(true);
  };

  return (
    <>
      {isPreviewOpen && (
        <div 
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 9999,
            display: 'flex', justifyContent: 'center', alignItems: 'center'
          }}
          onClick={() => setIsPreviewOpen(false)}
        >
          <button 
            style={{ 
              position: 'absolute', top: 20, right: 20, background: 'transparent', 
              border: 'none', color: '#fff', fontSize: '40px', cursor: 'pointer' 
            }}
            onClick={() => setIsPreviewOpen(false)}
          >
            &times;
          </button>
          <img 
            src={designs[activeIndex]} 
            alt="Fullscreen preview" 
            style={{ maxHeight: '90vh', maxWidth: '90vw', objectFit: 'contain' }} 
            onClick={(e) => e.stopPropagation()} 
          />
        </div>
      )}

      <div className="editor_toolbar">
        <div className="tool_group">
          <button className="tool_btn" onClick={handlePrev}>
            <img src="/static/images/left_arrow.svg" alt="arrow" />
          </button>
          <button className="tool_btn" onClick={handleNext}>
            <img src="/static/images/right_arrow.svg" alt="arrow" />
          </button>
        </div>

        <div className="tool_group">
          <button className="tool_btn active"><img src="/static/images/hand.svg" alt="arrow" /></button>
          <button className="tool_btn"><img src="/static/images/cursor_arrow.svg" alt="arrow" /></button>
          <button className="tool_btn"><img src="/static/images/icon-container.svg" alt="" /></button>
          <button className="tool_btn"><img src="/static/images/grid.svg" alt="" /></button>
        </div>

        <div className="tool_group" style={{ background: 'transparent' }}>
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#8CE352', marginRight: 5 }}></span>
          Grid
          <button className="tool_btn" onClick={toggleFullScreen}>
            <img src="/static/images/resize.svg" alt="resize" />
          </button>
        </div>
      </div>

      <div className="editor_card canvas_container">
        {/* Placeholder for the Mandala Graphic */}
        <img src={designs[activeIndex]} alt="Canvas Graphic" className="canvas_graphic" style={{ filter: 'hue-rotate(90deg)' }} />

        <div className="region_tag">
          Region 1
        </div>

        {activeOverlay === "text" && (
          <div className="text_overlay_mock">
            The Johnson Family
          </div>
        )}

        {activeOverlay === "upload" && (
          <div className="upload_overlay_mock">
            <div className="image_circle">
              <img src="/static/images/avtar.svg" alt="Upload mock" />
            </div>
          </div>
        )}

        <div className="canvas_badge">
          Canvas: 2048 x 2048 <VerifiedUserIcon />
        </div>
      </div>

      <div className="editor_card recent_designs">
        <div className="recent_header">
          <h3>Recent Designs</h3>
          <Link to="/recent-designs" className="view_all">View All Designs &rarr;</Link>
        </div>

        <div className="recent_gallery">
          <figure>
            <img src="/static/images/design1.png" className="thumbnail" alt="design 1" />
          </figure>
          <figure>
            <img src="/static/images/design2.png" className="thumbnail" alt="design 2" />
          </figure>
          <figure>
            <img src="/static/images/design3.png" className="thumbnail" alt="design 3" />
          </figure>
          <figure>
            <img src="/static/images/design4.png" className="thumbnail" alt="design 4" />
          </figure>
          <figure>
            <img src="/static/images/design5.png" className="thumbnail" alt="design 5" />
          </figure>
          <figure>
            <img src="/static/images/design6.png" className="thumbnail" alt="design 6" />
          </figure>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
